import React from 'react'

import {
  BuildVersionChecker,
  FeatureFlagsProvider,
  GoneFishin,
  ReactQueryClientProvider,
  Toaster,
  initializeSentry,
} from '@termly-web/common'

import fetchHealth from 'utils/fetchHealth'

import DashboardIntlProvider from 'components/DashboardIntlProvider'

import Router from './Router'

import './styles.scss'


const FLAGSMITH_ENVIRONMENT_ID = process.env.FLAGSMITH_ENVIRONMENT_ID

initializeSentry()


export default function App() {
  const preferredLocales = window.navigator.languages

  return (
    <FeatureFlagsProvider
      environmentID={ FLAGSMITH_ENVIRONMENT_ID }
    >
      <ReactQueryClientProvider>
        <DashboardIntlProvider
          preferredLocales={ preferredLocales }
        >
          <BuildVersionChecker />
          <GoneFishin
            fetchHealth={ fetchHealth }
          >
            <Router />
          </GoneFishin>
          <Toaster />
        </DashboardIntlProvider>
      </ReactQueryClientProvider>
    </FeatureFlagsProvider>
  )
}
